<template>
  <div class="col">
    <p>此网站、移动应用程序（"tobook.link"）和网络小部件（"Web-widget"）为tobook.link s.r.o.（注册号19608217）所有并由其运营，法定地址：Pavla Beneshe 750/8，布拉格19900。</p>
    <h6 class="mt-1 mb-1">
      关键术语
    </h6>
    <ul>
      <li><b>用户</b> - 指tobook.link网站和应用程序的任何用户（“服务提供商”或“客户”）。</li>
      <li><b>服务提供商</b> - 如果您是注册用户，并通过tobook.link预订页面提供商品和服务，则是您。</li>
      <li><b>客户</b> - 如果您是通过服务提供商预订服务，并且不是注册用户，则是您。</li>
      <li><b>支付提供商</b> - 指支持处理服务提供商服务支付的支付系统。</li>
      <li><b>交易费</b> - 是在转账金额上收取的百分比。详细信息请参阅<b-link :to="{name: 'pricing'}">条款</b-link>部分。</li>
      <li><b>服务费</b> - 是客户使用tobook.link预订系统而收取的固定金额。有关详细信息，请参见<b-link :to="{name: 'pricing'}">条款</b-link>部分。</li>
    </ul>
    <p>本条款（"条款"）构成您（"客户"或"服务提供商"，"您"）与我们之间关于访问和使用tobook.link，以及购买产品或服务（"服务"）所产生的法律约束协议（"协议"）。请确保您已经仔细阅读了这些条款。通过安装、使用、注册或访问tobook.link，您明确同意遵守所有这些条款。</p>
    <p>我们建议您打印或保存这些条款的副本以备查阅。更新的条款版本始终可在tobook.link应用程序中获得。上次修订条款的日期如上所示。</p>
    <p>未在tobook.link应用程序中注册的个人将只能查看和使用应用程序中可用的某些功能，但他们将无法使用应用程序的一些功能。</p>
    <h6 class="mt-5 mb-3">
      1. 服务的一般描述
    </h6>
    <p>1.1. tobook.link网站、移动应用程序和网络小部件是您作为客户可以使用的电子预订系统，您可以使用该系统预订所需服务的特定服务提供商（"服务提供商"）。可能的服务类型种类繁多，且不断扩展。</p>
    <p>1.2. 作为预订系统的提供者，我们不提供、提供、控制、提供、拥有或拥有任何在tobook.link应用程序中列出的服务。当客户订购服务并服务提供商确认已预订的服务（“tobook.link”）时，各方之间就形成了一项协议，并且tobook.link不被视为此协议（“协议”）的一方。同样，tobook.link不是服务提供商和客户之间任何合同关系的一方。</p>
    <h6 class="mt-5 mb-3">
      2. 使用条款
    </h6>
    <p>2.1. 使用网站、移动应用程序（"tobook.link"）和其中的注册（帐户创建）是免费的。</p>
    <p>2.2. 您可以在不注册为客户的情况下访问和使用网站（"tobook.link"）。但是，如果您希望成为服务提供商，您必须进行注册并创建帐户。</p>
    <p>2.3. 已年满18岁的个人可以在tobook.link上注册帐户。</p>
    <p>2.4. 注册时，您必须提供关于自己的准确、真实和正确的信息，并在任何更改时进行更新。有关您需要提供的数据的详细信息，请参阅我们的隐私政策。</p>
    <p>2.5. 帐户的注册和认证使用您的电话号码和电子邮件地址进行。</p>
    <p>2.6. 服务提供商不得泄露其登录详细信息；服务提供商必须将其保管并确保这些详细信息仅由自己知晓和使用；服务提供商不得透露或以其他方式使其他个人访问或使用这些详细信息。如果您有理由怀疑您的登录详细信息已丢失、被盗或以其他方式被滥用，或者可能被第三方访问，请立即通知我们。使用用户的标识代码执行的所有操作都被视为由用户执行，用户对此类操作的后果承担全部责任。</p>
    <h6 class="mt-5 mb-3">
      3. 预订服务
    </h6>
    <p>3.1. 在预订之前，客户必须确保服务符合其需求。</p>
    <p>3.2. 客户可以使用应用程序中提供的联系信息与服务提供商联系。</p>
    <p>3.3. 预订服务时，将向服务提供商发送关于日期和时间的预订请求。客户应收到确认预订的电子邮件或消息。</p>
    <p>3.4. 当前的预订信息将在服务提供商的个人帐户中提供。</p>
    <h6 class="mt-5 mb-3">
      4. 支付服务提供商的服务
    </h6>
    <p>4.1. 支付提供商</p>
    <ul>
      <li>tobook.link使用第三方支付提供商（以下简称“支付提供商”）直接处理支付，以向服务提供商的个人帐户支付。tobook.link采取合理预防措施确保支付提供商服务的可用性和安全性，但不能保证对支付提供商服务的不间断或连续访问，也不能保证支付提供商不会受到病毒或错误的影响。</li>
    </ul>
    <p>4.2. 责任</p>
    <ul>
      <li>服务提供商对在通过支付提供商支付其服务时维护客户权利负全责。</li>
      <li>如果支付或存款的收取违反了提供服务的国家法律，则服务提供商有责任不允许在其预订页面上启用支付或存款功能。否则，服务提供商承担单独责任。</li>
      <li>tobook.link不对支付提供商的错误负责。支付处理的访问可能会因维修、维护或引入新设备或服务而偶尔受限。我们将尽力提前通知任何计划中的中断，并尽一切可能尽快恢复设施的运作。</li>
      <li>服务提供商对服务总成本的间接税（如销售税、增值税、商品及服务税或服务税）以及适用时的额外商品或服务的销售额调整负全责。</li>
    </ul>
    <p>4.3. 由服务提供商设置的价格</p>
    <ul>
      <li>价格和任何费用将在支付提供商的支付页面上标明。</li>
      <li>客户最终支付服务的价格可能会根据客户在服务提供过程中购买的任何额外商品或服务进行调整。</li>
      <li>tobook.link还会从客户收取服务费，该费用将反映在应付款项的最终金额中。</li>
    </ul>
    <p>4.4. 支付服务提供商的服务</p>
    <ul>
      <li>tobook.link不会代表服务提供商收取付款；服务费将被视为客户直接向服务提供商支付的费用。在除去支付处理佣金后，服务提供商将获得客户决定支付的任何支付的100%。</li>
      <li>客户以最终价格支付服务，该价格以所列币种表示。客户所产生的货币兑换成本或其他费用将由客户承担，除了支付之外。</li>
    </ul>
    <p>4.5. 税收</p>
    <ul>
      <li>tobook.link不对服务提供商收取税款，因为服务提供商的服务是由服务提供商提供的，而不是tobook.link。如果客户通过支付提供商进行支付，tobook.link将提供到支付提供商的支付服务的链接，支付提供商将向客户的电子邮件发送发票。</li>
    </ul>
    <p>4.6. 预订转移</p>
    <ul>
      <li>如果客户在收到确认后希望转移预订（例如，时间/日期）部分或全部内容，则客户可以通过直接联系相关服务提供商进行操作。</li>
      <li>客户只有在预订时间不在服务提供商定义并在服务提供商条款中说明的特定时间段内时才能转移预订。客户可在首次向服务提供商发出请求时了解并了解取消政策。请注意，能否转移预订取决于所需时间内服务提供商的可用性。</li>
    </ul>
    <p>4.7. 取消政策、未出现</p>
    <ul>
      <li>除了法定权利外，在某些情况下，客户可能有权取消服务提供商的预订，原因是不可预见的情况或紧急情况。要取消预订，客户需要直接联系服务提供商。</li>
      <li>在紧急情况、不可预见的情况或其他有效原因的情况下，服务提供商也可以单方面取消预订，如服务提供商政策中规定的。</li>
    </ul>
    <p>4.8. 押金和预订取消</p>
    <ul>
      <li>服务提供商可能会要求支付从0到100%的服务成本作为确认预订的押金。我们强烈建议您在完成预订流程之前向服务提供商直接请求服务提供商的合同。请注意，押金可能是不可退还的。tobook.link不对向服务提供商支付的押金负责。</li>
      <li>如果客户发起预订取消，则押金退款问题应直接与服务提供商解决，根据其取消政策。</li>
      <li>如果服务提供商自行取消预订，则他们有责任退还客户的押金。如果未退款，则客户有权联系相关执法机构解决问题。客户还可以通过support@tobook.link通知我们此类事件，以便我们采取措施并封锁该服务提供商的预订页面。</li>
      <li>向客户退还押金由与服务提供商协商确定，不包括交易费用，也不包括服务费。</li>
    </ul>
    <p>4.9. 取消和未出现</p>
    <ul>
      <li>要取消预订，客户只能通过直接联系服务提供商进行操作。客户可在计划预订开始时间之前的时间段内取消预订，具体时间将由每个服务提供商单独确定。</li>
      <li>tobook.link建议客户在确认预订之前直接联系相关服务提供商，了解相关服务提供商的取消政策。</li>
    </ul>
    <h6 class="mt-5 mb-3">
      5. 评论和评分
    </h6>
    <p>5.1. 客户在接收服务后，可以为服务提供者留下评论并提供评分。</p>
    <p>5.2. 评论和评分必须真实，不得包含粗鲁和/或淫秽的表达。</p>
    <h6 class="mt-5 mb-3">
      6. 客户与服务提供者之间的争议
    </h6>
    <p>6.1. 如果向客户提供的服务与服务描述不完全匹配，客户有权最初要求服务提供者免费提供服务，以确保其与订购的服务及其描述相符。</p>
    <p>6.2. 如果客户在预订时知道或不可能不知道服务不符合其需求，或者服务不符合的原因是客户未提供完整的材料以接收服务，或者客户未准备好接收服务，或者客户未满足接收服务的其他预备条件或未提前通知服务提供者，则不认为服务与其描述不符。</p>
    <p>6.3. 在服务提供者因提供服务导致客户健康和/或财产受损的情况下，客户有权向法院提出索赔，要求对因此类服务导致的损失进行赔偿。</p>
    <p>6.4. 如果客户与服务提供者在争议问题上达不成协议，客户有权联系消费者权益保护中心解决争议。</p>
    <p>6.5. 如果客户或服务提供者不同意消费者权益保护中心的决定，双方有权诉诸法院，法院将根据法规解决争议。</p>
    <p>6.6. 请注意，欧洲委员会提供了一个可用于替代争议解决（ADR）的平台，网址为 http://ec.europa.eu/odr。</p>
    <h6 class="mt-5 mb-3">
      7. 责任和免责声明
    </h6>
    <p>7.1. 您对使用本网站及任何与我们相关的应用程序承担全部责任。您对本网站或任何内容的不满的唯一解决办法是停止使用本网站或任何此类内容。此限制是各方之间协商的一部分。</p>
    <p>7.2. tobook.link 不承诺本网站或任何内容、服务或本网站功能无错误或不中断，也不承诺任何缺陷将被纠正，或者您使用本网站将提供特定结果。本网站及其内容按照“原样”和“可得到”方式提供。</p>
    <p>7.3. 在任何情况下，tobook.link 对您不承担任何间接、后果性、示例性、偶然性或惩罚性的损害赔偿责任，包括利润损失，即使 tobook.link 已被告知可能发生此类损害。</p>
    <p>7.4. 如果尽管这些使用条款的其他规定，确定 tobook.link 对您因使用本网站或我们的应用程序而产生的任何损害或损失承担责任，tobook.link 的责任在任何情况下不得超过以下两者中的较大值：(1) 在对 tobook.link 提出首次索赔之前的六个月内支付的任何服务或本网站服务特征的订阅费或类似费用的总金额。</p>
    <p>7.5. tobook.link 不对因火灾、洪水、战争、社会动乱、罢工、停工、自然灾害、断电、计算机病毒或其他超出 tobook.link 控制范围的事件而无法履行或及时履行我们的义务承担责任。</p>
    <p>7.6. tobook.link 不控制也不保证任何服务提供者的服务的质量、安全性或适用性，以及服务的准确性、评级描述、有关服务的真实性或准确性的任何其他相关信息。我们不检查服务提供者注册的服务，包括其质量和符合性。服务提供者的评级、评论或任何其他相关信息不构成 tobook.link 对服务质量或符合性的保证或担保。tobook.link 仅提供服务的电子预订，因此在决定选择服务提供者时请始终仔细检查所有信息。</p>
    <p>7.7. 在法律允许的最大范围内，您应当保护、使 tobook.link、其员工和子公司免受任何索赔、责任、损害和费用，包括法院费用，由此产生或与用户访问网站、移动应用程序（“tobook.link”）和网络挂件或他们的使用有关。</p>
    <p>7.8. tobook.link 不承担任何明示或暗示的担保，包括准确性、非侵权、适销性和特定用途的任何担保。</p>
    <p>7.8.1 tobook.link 不能保证从本网站下载的任何文件都不含病毒、污染物或破坏性特征。</p>
    <p>7.9 tobook.link 不对与您使用本网站和/或任何 tobook.link 服务相关的任何第三方的行为、疏忽和行为承担责任。</p>
    <h6 class="mt-5 mb-3">
      8. 适用法律和争议解决
    </h6>
    <p>8.1. 在不影响强制性消费者保护法规的适用的前提下，本条款将受捷克共和国法律管辖。</p>
    <p>8.2. 如果用户与 tobook.link 之间因协议的条款而发生争议，用户有权书面或电子方式向我们提出投诉，提供他或她的姓名和联系信息、投诉提交日期和理由。我们将在 15 天内回复您的投诉。</p>
    <p>8.3. 如果争议无法通过协商解决，则任何一方都可以根据捷克共和国的立法将争议提交给捷克共和国的法院。</p>
    <h6 class="mt-5 mb-3">
      9. 知识产权
    </h6>
    <p>9.1. 本网站、移动应用程序（“tobook.link”）和网络挂件的内容，包括但不限于图片、视频、标志、菜单、网站、图形、颜色、工具、设计、方法、功能以及协助应用程序操作的任何软件，均受版权和属于我们以及各自权利持有人的所有其他知识产权的保护。未经许可，不得全文或部分复制内容，也不得进行任何形式的复制。</p>
    <p>9.2. 用户只被允许查看应用程序及其内容。用户仅被允许执行临时性的个人使用复制活动，这些复制活动具有临时性质，并且是查看网站、移动应用程序（“tobook.link”）和网络挂件及其内容的重要组成部分。请注意，任何在网站、移动应用程序（“tobook.link”）和网络挂件上发表作品的作者均有权要求对其作品的作者身份进行认定，并反对对作品进行任何歪曲或其他修改，包括可能损害他们的名誉或声誉的作品。</p>
    <p>9.3. 区分应用程序上要购买的服务的商标是其各自所有者的注册商标，用于描述和宣传应用程序上的服务。我们和所有其他注册商标所有者将拥有我们拥有的商标的专有使用权。任何非法或未经授权使用此类商标均受到禁止，并可能引起严重的法律后果。</p>
    <p>9.4. 如果您有兴趣在公开可用的网页上使用应用程序内容的链接，请发送电子邮件至以下地址与我们联系：support@tobook.link。</p>
    <h6 class="mt-5 mb-3">
      10. 协议的有效性和终止
    </h6>
    <p>10.1. 本协议有效直至终止。</p>
    <p>10.2. 用户可以随时通过终止在应用程序上的注册（删除其账户），以及终止使用和访问应用程序并从其设备中删除应用程序来终止本协议。根据 GDPR，用户有权被遗忘的权利。这意味着根据您的要求，我们将删除我们收集到的所有个人数据。</p>
    <p>10.3. 如果用户终止协议，则所有当前的服务预订将自动取消，并根据预订取消条款（预订取消和退款条款）退款。</p>
    <p>10.4. 对于 tobook.link 限制、暂停或拒绝用户访问 tobook.link 的情况和前提条件如下（严重或重复违禁行为的情况下）：</p>
    <ul>
      <li>法律要求。</li>
      <li>有理由相信用户违反了适用法律。</li>
      <li>违反了条款的任何要求。</li>
      <li>针对用户的投诉，反复取消预订。</li>
      <li>需要保护个人社会价值和主观权利。</li>
      <li>有理由相信用户对应用程序的持续使用对应用程序或第三方的安全构成威胁。</li>
      <li>防止欺诈或任何其他非法活动。</li>
    </ul>
    <h6 class="mt-5 mb-3">
      11. 最终条款
    </h6>
    <p>11.1. tobook.link 保留随时更改条款的权利，特别是由于适用法律和法规的变化。条款的最后修订日期如上所示。您可以拒绝对条款的更改，并通过立即终止在应用程序上的注册（删除您的帐户），以及终止使用和访问应用程序来终止协议。在这种情况下，您对早期版本的条款的同意仍然有效，并将适用于您和我们之间的任何争议。通过继续访问或使用网站、移动应用程序（“tobook.link”）和网络挂件及其服务，您同意对条款的更改。</p>
    <p>11.2. 如果我们认为条款的更改是实质性的，tobook.link 将在变更生效前 1 (一) 个日历月通知用户。尽管上述规定，以下条款的变更将立即生效：(i) 对用户更有利；(ii) 法律要求；或 (iii) 为现有服务添加新服务或附加功能；或 (iv) 不减少用户的权利或增加用户的责任 —— 如果在变更通知中指明。</p>
    <h6 class="mt-5 mb-3">
      12. 客户支持服务和联系方式
    </h6>
    <p>12.1. 您可以通过“获取帮助”部分下的联系选项向 <b-link
      :to="{name: 'partners'}"
    >tobook.link</b-link> 提出任何问题。</p>
  </div>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  name: 'CnTermsOfUse',
  components: {
    BLink,
  },
}
</script>

<style scoped>

</style>
